import React,{useState,useEffect} from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Box
} from "@mui/material";
import "./ApproveNominations.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DatePicker from 'react-datepicker';
import LeftArrow from '@mui/icons-material/KeyboardArrowLeft';
import RightArrow from '@mui/icons-material/KeyboardArrowRight';
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_API_URL } from "../../utils/constants";
import  NominationList from "./NominationList";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


const ApproveNominations = ({track}) => {
  const baseURL = BASE_API_URL;
  const loggedInUser= useSelector(state=> state.poc.enterpriseID);  
  const [courses, setCourses]= useState({});
  const tabs = Object.keys(courses).sort();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
   const theme = createTheme({
    typography: {
     fontFamily: "Graphik-Regular",
    },
   });
  const [sessions, setSessions] = useState({});
  const [loadingSessions, setLoading] = useState({});
  const [errorSessions, setError]= useState({});
  const [selectedSession, setSelectedSession]= useState(null);

  const fetchCourses= async(loggedInUser)=>{
    try{
      const res= await axios.get(`${baseURL}/${track}/fetchCourses/${loggedInUser}`,{
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        }
      }
    );
    console.log(res.data);
    setCourses(res.data);
    }catch(err){
      console.error("Unable to fetch courses where loggedIn user is Approver");
    }
  }
   const [selectedDate, setSelectedDate] = useState(new Date());
   const [month, setMonth] = useState((new Date().getMonth()) + 1);
   const [year, setYear] = useState((new Date()).getFullYear()); 

  const dateSelectorHandler = (date) => {
  setSelectedDate(date);
  setMonth(date.getMonth() + 1);
  setYear(date.getFullYear());
 };

  const fetchSessions= async(courseCode)=>{
    try{
      setLoading((prev) => ({ ...prev, [courseCode]: true }));

       const res= await axios.get(`${baseURL}/${track}/fetchSessions`,
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },params:{
          courseCode,
          month,
          year
        }
      });
      setSessions((prevState) => ({
        ...prevState,
        [courseCode]: res.data,
      }));
      setError((prev) => ({ ...prev, [courseCode]: false }));
    }catch(err){
      console.log(`Error in fetching sessions for courseCode: ${courseCode}-> ${err}`);
      setError((prev) => ({ ...prev, [courseCode]: true }));
    }
    finally{
      setLoading((prev) => ({ ...prev, [courseCode]: false }));
    }
  }

 useEffect(() => {
    if (loggedInUser) {
      fetchCourses(loggedInUser);
    }
  }, [loggedInUser]);


function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

const handleSessionSelection=(sessionCode,date, courseName)=>{
  setSelectedSession({courseCodeNm:sessionCode,date, selectedCourseName:courseName});
}

 const goBack = () => {  
  setSelectedSession(null);
 };

  if(selectedSession){
    return <ThemeProvider theme={theme}>
      <div className="banner training-banner-box">
     <img
      src={process.env.PUBLIC_URL + "/images/Home/training-banner.png"}
      alt="banner"
      className="home-banner"
     />
     <h1 className="banner-content">Nominations' Approver View</h1>
    </div>
    <Box className="goback_section">
      <Button className="goback_button" onClick={() => goBack()}>
       Go Back
      </Button>
     </Box>
    <NominationList sessionObj={selectedSession}/>
    </ThemeProvider>
  }
  else{ 
    return<ThemeProvider theme={theme}>
      <div className="banner training-banner-box">
     <img
      src={process.env.PUBLIC_URL + "/images/Home/training-banner.png"}
      alt="banner"
      className="home-banner"
     />
     <h1 className="banner-content">Nominations' Approver View</h1>
    </div>
    <Box className="SME_main">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
            {tabs.map((tab, i) => (
                  <Tab key={i} label={tab} {...a11yProps(i)} />
                ))}
            </Tabs>
          </Box>
    <Box className="SME_session_container">
       <p className="upload_section_para">
        This section allows the Approvers to review the skills of the candidates against a
        course to which the nominations are uploaded. The tool allows you to approve /
        reject the nominations based on their skills as defined by the course
        pre-requisites to attend the training.
       </p>
    </Box>
     <Box className="smedate-picker-container" sx={{fontWeight: '700'}}>
      <label htmlFor="smedate" className="date-picker-label">
        Select Month:&nbsp;
      </label>
      <DatePicker
        id="smedate"
        selected={selectedDate}
        className="smedate-picker"
        onChange={(date) => dateSelectorHandler(date)}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        renderCustomHeader={({
          date,
          changeYear,

        }) => (
          <div className="custom-header">
            <LeftArrow className = "arrow" onClick={() => changeYear(date.getFullYear() - 1)} />
            <span>{date.toLocaleString('default', { month: 'long' })} {date.getFullYear()}</span>
            <RightArrow className = "arrow" onClick={() => changeYear(date.getFullYear() + 1)} />
          </div>
        )}
      />
      </Box>

        {tabs &&
        tabs.length>0 &&
        tabs[value]  &&
        courses[tabs[value]] &&
        courses[tabs[value]].map((course)=>
        <Accordion
          key={course.co}
        onChange={(event, isExpanded) => {
          if (isExpanded) {
            fetchSessions(course?.courseCode);
          }
        }}
        >
          <AccordionSummary
          expandIcon={<ArrowDropDownIcon/>}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography sx={{ textTransform: 'capitalize' }}>{course?.courseName}</Typography>

        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper} sx={{ mt: 3 }}>
      {loadingSessions[course.courseCode] ? (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      ) : sessions[course.courseCode] && sessions[course.courseCode].length === 0 ? (
        <Typography p={3} textAlign="center">
          No sessions available for the selected month
        </Typography>
      ) : (
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell><b>Session Code</b></TableCell>
              <TableCell><b>Start Date</b></TableCell>
              <TableCell><b>End Date</b></TableCell>
              <TableCell><b>Delivery Mode</b></TableCell>
              <TableCell><b>Timing</b></TableCell>
              <TableCell><b>Duration</b></TableCell>
              <TableCell><b>Total Seats</b></TableCell>
              <TableCell><b>Action</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessions[course.courseCode] && 
            sessions[course.courseCode].map((row, index) => (
              <TableRow key={index} hover>
                <TableCell>{row.sessionCode}</TableCell>
                <TableCell>{formatDate(row.startDate)}</TableCell>
                <TableCell>{formatDate(row.endDate)}</TableCell>
                <TableCell sx={{textTransform:"capitalize"}}>{row.deliveryMode}</TableCell>
                <TableCell>{row.timing}</TableCell>
                <TableCell>{row.duration}</TableCell>
                <TableCell>{row.totalSeats}</TableCell>
                <TableCell>
                  <Button sx={{textTransform:"none"}}
                  onClick={()=>
                  handleSessionSelection(row?.sessionCode,formatDate(row?.startDate), course?.courseName)}
                  >View Nominations
                  </Button> 
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
        </AccordionDetails>
        </Accordion>)
        }
  </Box>
    </ThemeProvider>
     }
  
};

export default ApproveNominations;
